import { createModel } from '@rematch/core';
import { AppDispatch, AppState } from '../../types/store';

export type ModalsStore = {
  isAddNewPickupVisible: boolean;
  isAddAmountVisible: boolean;
  isEmailVerificationVisible: boolean;
};

export type ModalsReducers = {
  toggleIsAddNewPickupVisible: () => void;
  toggleIsAddAmountVisible: () => void;
  toggleIsEmailVerificationVisible: () => void;
};

export type ModalsDispatch = ModalsReducers & {
  setIsAddNewPickupVisible: (isVisible: boolean) => void;
  setIsAddAmountVisible: (isVisible: boolean) => void;
  setIsEmailVerificationVisible: (isVisible: boolean) => void;
};

const initialState: ModalsStore = {
  isAddNewPickupVisible: false,
  isAddAmountVisible: false,
  isEmailVerificationVisible: false
};

export const modals = createModel({
  //@ts-ignore
  effects: (dispatch: AppDispatch) => ({
    toggleIsAddNewPickupVisible(_: undefined, state: AppState) {
      const {
        modals: { isAddNewPickupVisible }
      } = state;
      dispatch.modals.setIsAddNewPickupVisible(!isAddNewPickupVisible);
    },
    toggleIsAddAmountVisible(_: undefined, state: AppState) {
      const {
        modals: { isAddAmountVisible }
      } = state;
      dispatch.modals.setIsAddAmountVisible(!isAddAmountVisible);
    },
    toggleIsEmailVerificationVisible(_: undefined, state: AppState) {
      const {
        modals: { isEmailVerificationVisible }
      } = state;
      dispatch.modals.setIsEmailVerificationVisible(!isEmailVerificationVisible);
    }
  }),
  reducers: {
    setIsAddNewPickupVisible(state, isVisible) {
      return {
        ...state,
        isAddNewPickupVisible: isVisible
      };
    },
    setIsAddAmountVisible(state, isVisible) {
      return {
        ...state,
        isAddAmountVisible: isVisible
      };
    },
    setIsEmailVerificationVisible(state, isVisible) {
      return {
        ...state,
        isEmailVerificationVisible: isVisible
      };
    }
  },
  state: initialState
});
